import clsx from 'clsx';
import { memo, useMemo } from 'react';

import type { Slot } from '../types';

import Image from '@shared/Image';
import type { PkTheme } from '@shared-types/common.types';
import { RoundPhase } from '@shared-types/match.types';
import { imgBaseUrl } from '@utilities/WindowContext';

import * as classes from './styles.module.scss';

const CardHeader = ({ competition, theme }: { competition: Slot['competition']; theme: PkTheme }) => {
  const compDisplayName = useMemo(() => {
    const phaseNameMap = {
      [RoundPhase.QUALIFYING]: competition?.qualifyingName,
      [RoundPhase.PREQUALIFYING]: competition?.prequalifyingName,
      default: competition?.displayName,
    } as const;
    return phaseNameMap[competition?.phase?.toUpperCase()] ?? phaseNameMap['default'];
  }, [competition]);

  const compCode = competition?.cupFolder === 'friendlies' ? 'friendlies' : competition?.compCode;

  return (
    <div
      className={clsx(
        'pk-d--flex',
        'pk-align-items--center',
        theme === 'dark' && 'pk-p--xs2 pk-pr--xl',
        theme === 'dark' && classes.header,
      )}
    >
      <Image
        className='pk-flex--shrink-0 pk-mr--xs2'
        src={`${imgBaseUrl}/imgml/uefacom/elements/logos/competitions/${theme}/${compCode}` + '.svg'}
        width={20}
        height={20}
      />
      <span className={clsx('pk-font--base-semibold pk-font-size--xs pk-line-height--md', classes.compName)}>
        {compDisplayName}
      </span>
    </div>
  );
};

export default memo(CardHeader);
